import React from 'react'

interface SpinnerProps { size?: number; color?: string; style?: React.CSSProperties }

export const Spinner: React.FC<SpinnerProps> = ({ size = 18, color = 'currentColor', style }) => (
  <>
    <style>{`@keyframes ekkam-spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`}</style>
    <span style={{ display: 'inline-block', width: size, height: size, border: `2px solid transparent`, borderTopColor: color, borderRadius: '50%', animation: 'ekkam-spin 0.7s linear infinite', flexShrink: 0, ...style }} />
  </>
)
